import axios from "@/api/AuthAPI/auth-request-api";
import { roomService } from "@/config/host.config";
import { AxiosResponse } from "axios";
import {
  IRoomServiceByRoomResponse,
  IRoomServiceListResponse,
  IRoomServiceMutationResponse,
  IRoomServiceQuery,
  IRoomServiceRequest,
} from "@/@types/room-service/room-service";

const buildParams = (query: IRoomServiceQuery): Record<string, unknown> => {
  const params: Record<string, unknown> = {};
  Object.keys(query).forEach((key) => {
    const value = (query as Record<string, unknown>)[key];
    if (value !== undefined && value !== null && value !== "") {
      params[key] = value;
    }
  });
  return params;
};

export const RoomServiceAPI = {
  getAll(
    query: IRoomServiceQuery = {}
  ): Promise<AxiosResponse<IRoomServiceListResponse>> {
    return axios.get(roomService.adminAll, { params: buildParams(query) });
  },

  getByRoom(
    query: IRoomServiceQuery
  ): Promise<AxiosResponse<IRoomServiceByRoomResponse>> {
    return axios.get(roomService.adminByRoom, { params: buildParams(query) });
  },

  getById(id: string): Promise<AxiosResponse<IRoomServiceRequest>> {
    return axios.get(`${roomService.my}/${id}`);
  },

  addForAdmin(
    body: Partial<IRoomServiceRequest>,
    vroom_id?: string
  ): Promise<AxiosResponse<IRoomServiceMutationResponse>> {
    const config = vroom_id ? { params: { vroom_id } } : {};
    return axios.post(roomService.admin, body, config);
  },

  updateForAdmin(
    id: string,
    body: Partial<IRoomServiceRequest> & { note?: string }
  ): Promise<AxiosResponse<IRoomServiceMutationResponse>> {
    return axios.put(`${roomService.admin}/${id}`, body);
  },

  cancelMy(id: string): Promise<AxiosResponse<IRoomServiceMutationResponse>> {
    return axios.delete(`${roomService.my}/${id}`);
  },

  health(): Promise<
    AxiosResponse<{ status: string; service: string; timestamp: string }>
  > {
    return axios.get(roomService.health);
  },
};
